import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { PlatformLocation } from '@angular/common';
import Swal from 'sweetalert2'
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CadastroPoderesInternosService {

  usuariosCorpGet$ = new BehaviorSubject(null);
  cadastroPoderesGet$ = new BehaviorSubject(null);
  cadastroPoderesPost$ = new BehaviorSubject(null);
  cadastroPoderesPut$ = new BehaviorSubject(null);
  cadastroPoderesDelete$ = new BehaviorSubject(null);

  constructor(private http: HttpClient, private platformLocation: PlatformLocation) { }

  get() {
    try {
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/PoderesInternos/consulta_poderes_internos/" + environment.empresa;

      this.http.get(url).subscribe({
        next: (data) => this.cadastroPoderesGet$.next(data),
        error: (error: HttpErrorResponse) => {
          this.cadastroPoderesGet$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.cadastroPoderesGet$.unsubscribe(),
          this.cadastroPoderesGet$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }

  //Incluir Faixa
  post(faixa: any) {
    try {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      faixa.empresa = environment.empresa;

      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/PoderesInternos/Incluir"

      this.http.post(url, faixa, { headers: headers }).subscribe({
        next: (data) => this.cadastroPoderesPost$.next(data),
        error: (error: HttpErrorResponse) => {
          this.cadastroPoderesPost$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.cadastroPoderesPost$.unsubscribe(),
          this.cadastroPoderesPost$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }

  //Editar Faixa
  put(faixa: any) {
    try {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      faixa.empresa = environment.empresa;

      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/PoderesInternos/Editar"

      this.http.put(url, faixa, { headers: headers }).subscribe({
        next: (data) => this.cadastroPoderesPut$.next(data),
        error: (error: HttpErrorResponse) => {
          this.cadastroPoderesPut$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.cadastroPoderesPut$.unsubscribe(),
          this.cadastroPoderesPut$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }

  //Deletar Faixa
  del(faixa: any) {
    try {
      const options = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
        body: faixa
      };

      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/PoderesInternos/Excluir";
      faixa.empresa = environment.empresa;

      this.http.delete(url, options).subscribe({
        next: (res: any) => this.cadastroPoderesDelete$.next(res),
        error: (error: HttpErrorResponse) => {
          this.cadastroPoderesDelete$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.cadastroPoderesDelete$.unsubscribe(),
          this.cadastroPoderesDelete$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }

  obterUsuariosCorp(busca) {
    try {
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/CorpUsuarios/Obter/" + environment.empresa + "/" + busca;

      this.http.get(url).subscribe({
        next: (data) => this.usuariosCorpGet$.next(data),
        error: (error: HttpErrorResponse) => {
          this.usuariosCorpGet$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.usuariosCorpGet$.unsubscribe(),
          this.usuariosCorpGet$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
      throw e;
    }
  }
}
